import React, {useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Modal from '../Modal/Modal';
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMailBulk} from "@fortawesome/free-solid-svg-icons";
import AxiosConfig from "../../services/AxiosConfig";

function BlocCrmDisable() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [stateDisableEmail, setStateDisableEmail] = useState(null);

    useEffect(() => {
        verifyDisableEmail();

        const intervalId = setInterval(() => {
            verifyDisableEmail();
        }, 10000);

        return () => clearInterval(intervalId);
    }, []);

    const verifyDisableEmail = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/crm/crm_status`);
            setStateDisableEmail(response.data.status);
        } catch (error) {
            console.error('error', error);
        }
    }

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

    return (
         stateDisableEmail === true ? (
             <div style={{
                 backgroundColor: "#f8d7da",
                 color: "#721c24",
                 padding: "10px",
                 borderRadius: "5px",
                 marginBottom: "20px",
                 display: "flex",
                 alignItems: "center",
                 gap: "10px"
             }}>
                 <FontAwesomeIcon icon={faMailBulk}/>
                 {" "} L'ENVOI DES MAILS EST ACTUELLEMENT DÉSACTIVÉ
             </div>
         ) :  ('')
    );
}

export default BlocCrmDisable;
